<template>
    <div class="container">
        <div class="item-headder">
            <div> 
                <h2><span>New invoice<span v-if="invoiceInfo.note != 0">: {{invoiceInfo.note}}</span></span><span class="pill xl yellow">Draft</span></h2>
                <p>
                    <span>#{{invoiceInfo.id}}</span>
                </p>
            </div>
        </div>
        <div class="action-panel">
            <div class="btn" v-on:click="saveInvoice()">Save</div>
        </div>
        <div class="flex-side-by-side">
            <div>
                <h2>Customerinformation</h2>
                <div class="div-table row">
                    <div>
                        <p>ID</p>
                        <span>
                            {{invoiceInfo.customer_id}} 
                        </span>
                    </div>
                    <div>
                        <p>Name</p>
                        <span>
                            {{invoiceInfo.customer_name}}
                        </span>
                    </div>
                    <div>
                        <p>Adress</p>
                        <span>
                            {{invoiceInfo.customer_address}}
                        </span>
                    </div>
                    <div>
                        <p>Postal-code</p>
                        <span>
                            {{invoiceInfo.customer_postal}}
                        </span>
                    </div>
                    <div v-if="invoiceInfo.customer_cvr != 0">
                        <p>CVR</p>
                        <span>
                            {{invoiceInfo.customer_cvr}}
                        </span>
                    </div>
                </div>
            </div>
            <div>
                <h2>Invoiceinformation</h2>
                <div class="div-table row">
                    <div>
                        <p>ID</p>
                        <span>
                            #{{invoiceInfo.id}}
                        </span>
                    </div>
                    <div v-if="invoiceInfo.cart_id != 0">
                        <p>Cart ID</p>
                        <span>
                            #{{invoiceInfo.cart_id}}
                        </span>
                    </div>
                    <div>
                        <p>Note</p>
                        <span>
                            <input type="text" v-model="invoiceInfo.note" maxlength="255"/>
                        </span>
                    </div>
                    <div>
                        <p>Creation day</p>
                        <span>
                            {{dateTimeFormat(invoiceInfo.creation_day)}}
                        </span>
                    </div>
                    <div v-if="invoiceInfo.payment_day">
                        <p>Payment day</p>
                        <span>
                            {{dateTimeFormat(invoiceInfo.payment_day)}}
                        </span>
                    </div>
                    <div>
                        <p>Creator type</p>
                        <span class="capitalize">{{invoiceInfo.creator}}</span>
                    </div>
                </div>
            </div>
        </div>

        <h2>Products in invoice</h2>
        <table class="products-table">
            <tr>
                <th>Function</th>
                <th>Type</th>
                <th>Product</th>
                <th>Data field</th>
                <th>Amount</th>
                <th>Unit Price</th>
                <th>Price</th>
            </tr>
            <tr v-for="(row, index) in invoiceInfo.data" :key="index">
                <td width="87px">
                    <div v-on:click="invoiceInfo.data.splice(index,1)" class="btn sm center">Remove</div>
                </td>
                <td>
                    <select v-model="row.action" v-on:change="row.data_one = '';row.unit_price = 0;">
                        <option value="create">Create</option>
                        <option value="change">Change</option>
                        <option value="extend">Extend</option>
                        <option value="delete">Delete</option>
                        <option value="pay">Pay</option>
                        <option value="referal">Referal</option>
                        <option value="coupon">Coupon</option>
                    </select>
                </td>
                <td>
                    <div class="flex">
                        <select v-if="row.action == 'create'" v-model="row.productO" v-on:change="row.unit_type = row.productO.recurringperiod; row.unit_price = valueFormater(row.productO.price*periodCalculator(row.unit_type))">
                            <option selected disabled>Select plan</option>
                            <option :value="product_plan" v-for="product_plan in product_plans" :key="product_plan.id">
                                {{product_plan.typetitle}} - {{product_plan.title}} - {{product_plan.price*periodCalculator(product_plan.recurringperiod)}} DKK
                            </option>
                        </select>

                        <select v-else-if="row.action=='change'" v-model="row.productO" v-on:change="row.unit_type = 'once'; row.data_one = row.productO.uid; row.unit_price = valueFormater(product_plans.find(dat => { return row.data_one==dat.setting }).price*periodCalculator(row.unit_type))">
                            <option selected disabled>Select product</option>
                            <option v-for="product in customerProducts" :key="product.uid" :value="product">
                                {{product.status}} - {{product.supportid}} - {{product.description}}
                            </option>
                        </select>

                        
                        <select v-else-if="row.action=='extend'" v-model="row.productO" v-on:change="row.unit_type = 'month'; row.data_one = row.productO.settings; row.unit_price = valueFormater(product_plans.find(dat => { return row.data_one==dat.setting }).price*periodCalculator(row.unit_type))">
                            <option selected disabled>Select product</option>
                            <option v-for="product in customerProducts" :key="product.uid" :value="product">
                                {{product.status}} - {{product.supportid}} - {{product.description}}
                            </option>
                        </select>
                        
                        <select v-if="row.action=='delete'" v-model="row.productO" v-on:change="row.unit_type = 'once';">
                            <option selected disabled>Select product</option>
                            <option v-for="product in customerProducts.filter(dat => { return dat.status=='active' })" :key="product.uid" :value="product">
                                {{product.status}} - {{product.supportid}} - {{product.description}}
                            </option>
                        </select>

                        <!-- IF CHANGE SELECT PLAN-->
                        <select v-if="row.action=='change'" v-model="row.data_one" v-on:change="row.unit_type = 'once'; row.unit_price = valueFormater(product_plans.find(dat => { return row.data_one==dat.setting }).price*periodCalculator(row.unit_type))">
                            <option disabled>Select plan</option>
                            <option :value="product_plan.uid" v-for="product_plan in product_plans.filter(dat => { return row.productO.productid==dat.categoryid })" :key="product_plan.uid">
                                {{product_plan.title}}
                            </option>
                        </select>
                    </div>
                </td>
                <td>
                    <div class="multiline">
                        <p>{{row.data_one}}</p>
                        <!--IF CHANGE SET NEW SETTING HERE-->
                        <!--IF REFERAL SET CODE HERE-->
                        <!--IF COUPON SET CODE HERE-->
                        
                        <p>{{row.data_two}}</p>
                        <p>{{row.data_three}}</p>
                    </div>
                </td>
                <td>
                    <div class="flex">
                        <input type="number" v-model="row.unit_amount"/>
                        <select v-if="row.action == 'create'" v-model="row.unit_type" v-on:change="row.unit_price = valueFormater(row.productO.price*periodCalculator(row.unit_type))">
                            <option value="kilometer">KM</option>
                            <option value="once">One time</option>
                            <option value="hour">Hour</option>
                            <option value="day">Day</option>
                            <option value="month">Month</option>
                            <option value="quarter">Quarter</option>
                            <option value="half-yearly">Half Year</option>
                            <option value="year">Year</option>
                        </select>
                        <select v-else-if="row.action == 'delete'" v-model="row.unit_type">
                            <option value="once">One time</option>
                        </select>
                        <select v-else v-model="row.unit_type" v-on:change="row.unit_price = valueFormater(product_plans.find(dat => { return row.data_one==dat.setting }).price*periodCalculator(row.unit_type))">
                            <option value="kilometer">KM</option>
                            <option value="once">One time</option>
                            <option value="hour">Hour</option>
                            <option value="day">Day</option>
                            <option value="month">Month</option>
                            <option value="quarter">Quarter</option>
                            <option value="half-yearly">Half Year</option>
                            <option value="year">Year</option>
                        </select>
                    </div>
                </td>
                <td>
                    <div class="flex">
                        <input type="number" step="any" v-model="row.unit_price"/>
                        <span>DKK</span>
                    </div>
                </td>
                <td>{{valueFormater(row.unit_price)*row.unit_amount}} DKK</td>
            </tr>
            <tr>
                <td colspan="7">
                    <div class="btn center" v-on:click="addRow()">Add row</div>
                </td>
            </tr>
            <tr v-if="invoiceInfo.data.length>0">
                <td colspan="5"></td>
                <td>Total</td>
                <td>{{calculateInvoice}} DKK</td>
            </tr>
        </table>
    </div>
</template>
<style scoped lang="scss">
    .item-headder{
        p, h2{
            display: flex;
            align-items: center;
        }
        h2 .pill{
            margin-left: 10px;
        }
    }
    .flex-side-by-side{
        display: flex;
        flex-wrap: wrap;
        margin: 0 -1rem;
        &>div{
            flex-grow: 2;
            margin: 1rem;
        }
    }
    .products-table{
        td .multiline{
            display: flex;
            flex-direction: column;
            p{
                margin: 0;
            }
        }
        td .flex{
            display: flex;
            &>*:not(span){
                width: 40px;
                flex-grow: 2;
                flex-shrink: 2;

            }
        }
    }
</style>
<script>

export default {
    name: 'CreateInvoice',
    data() {
        return {
            invoiceID: 0,
            product_plans: [],
            customerProducts: [],
            invoiceInfo: {
                id:0,
                customer_id: 0,
                note:"",
                cart_id:0,
                creator:"supporter",
                creation_day: new Date(),
                payment_day:null,
                customer_name:"",
                customer_address:"",
                customer_postal:"",
                customer_cvr:"",
                data:[
                ]
            },
            emptyrow: {
                supportid:"",
                invoice_id:0,
                product:0,
                productO: {

                },
                unit_price:0,
                unit_type:"month",
                unit_amount:1,
                unit_note:"",
                status:"waiting",
                action:"create",
                data_one:null,
                data_two:null,
                data_three:null
            },
        }
    },
    computed: {
        calculateInvoice(){
            var sum = 0;
            var vue = this;
            if(this.invoiceInfo.data.length>0){
                this.invoiceInfo.data.forEach(data => { sum += (data.unit_amount * vue.valueFormater(data.unit_price))});
            }
            return sum;
        },
    },
    methods: {
        valueFormater(value){
            return parseFloat(value).toFixed(2);
        },
        periodCalculator(type){
            var period_length = 1;
            if(type=="kilometer"){
                period_length = 1;
            }else if(type=="hour"){
                period_length = 0.0013888888888889;
            }else if(type=="day"){
                period_length = 0.0333333333333333;
            }else if(type=="month"){
                period_length = 1;
            }else if(type=="quarter"){
                period_length = 3;
            }else if(type=="half-yearly"){
                period_length = 6;
            }else if(type=="year"){
                period_length = 12;
            }
            return period_length;
        },
        getCustomerData(){
            var vue = this;
            this.$socket.client.emit('getUserInfo',vue.$route.params.uniqueid, (error, response) => {
                if(error=='200'){
                    vue.invoiceInfo.customer_id = response.id;
                    vue.invoiceInfo.customer_name = response.name;
                    vue.invoiceInfo.customer_address = response.address.split(", ")[0];
                    vue.invoiceInfo.customer_postal = response.address.split(", ")[1];
                    vue.invoiceInfo.customer_cvr = response.company_no;
                    this.getCustomerProducts();
                    this.getProductPlans();
                }
            })
        },
        getProductPlans(){
            var vue = this;
            this.$socket.client.emit('getProductPlanInfo',null, (error, response) => {
                if(error=='200'){
                    vue.product_plans = response;
                }
            })
        },
        getCustomerProducts(){
            var vue = this;
            this.$socket.client.emit('getUserProducts',vue.$route.params.uniqueid, (error, response) => {
                if(error=='200'){
                    vue.customerProducts = response;
                }
            })
        },
        saveInvoice(){
            var vue = this;
            this.$socket.client.emit('createInvoice',vue.invoiceInfo, (error, response) => {
                if(error=='200'){
                    console.log("created invoice - redirect"+ response);
                    //vue.$router.push('/invoices/'+vue.invoiceInfo.id);
                }
            })
        },
        addRow(){
            this.emptyrow.invoice_id = this.invoiceID;
            this.invoiceInfo.data.push( JSON.parse(JSON.stringify(this.emptyrow)));
        },
        invoideIDgenerator(){
            this.invoiceID = Math.floor((Math.random() * 2137483647) + 10000000);
            this.invoiceInfo.id = this.invoiceID;
        },
        dateTimeFormat : function(input){
            var date = new Date(input);
            return date.getDate() + ". " + this.$store.state.monthsShort[date.getMonth()] + " " + date.getFullYear() + " - " + ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2) + ":" + ("0" + date.getSeconds()).slice(-2);
        }
    },
    mounted() {
        this.getCustomerData();
        this.invoideIDgenerator();
        this.addRow();
    },
    
}
</script>